export interface CustomTheme {
  /**
   * 仅用于人工check数据，无实际代码逻辑用途
   */
  brandName: string;
  /**
   * logo 图片地址
   * 统一上传到集团店的EB后台
   */
  logoUrl: string;
  /**
   * logo 宽高比例 2比1
   */
  logoWidth: number;
  logoHeight: number;
  /**
   * 主色包括：icon 、主按钮背景色、link/辅按钮 文字色对应需求中的选中色
   */
  primaryColor: string;
  /**
   * 次要色：包括（按钮背景色、菜单选中色）
   * 一般和 primaryColor 相同
   * 可优化合并至 primaryColor ，目前定义有点重复
   */
  slaveColor: string;
  /**
   * 带透明度的次要色，主要用于标签背景
   * 一般是 slaveColor 的 rgba 形式
   */
  slaveTransparent: string;
  /**
   * 次要字体颜色：包括（按钮文字色、选中菜单的文字色）
   * 要么黑，要么白，取决于 primaryColor 和文字色的对比程度
   */
  slaveTextColor: string;
  /**
   * 侧边栏背景色
   */
  sideBarBgColor: string;
  /**
   * 侧边栏选中背景色
   */
  sideBarSelectedBgColor: string;
  /**
   * 概览页（zkt-c-report）图表柱状颜色，一般和 primaryColor 一致
   * 新 eb 不适用，保持两个系统定义的一致性
   */
  echartBarColor: string;
}
export interface TypeBoardCustomTheme {
  // id
  boardCustomThemeConfigId?: number;
  // 配置
  customThemeJson?: string;
  // 开关
  isOpen?: string;
  // 名称
  themeName?: string;
}
// 十六进制颜色 转为 rgba格式
export const hexToRgba = (hex: string, alpha = 1): string => {
  try {
    // 检查十六进制颜色格式是否正确
    const validHex = /^#([0-9a-f]{3}){1,2}$/i.test(hex);
    if (!validHex) {
      throw new Error("Invalid hex color format");
    }
    // 处理 "#f00" 转换为标准形式 "#ff0000"
    const hexFormatted =
      hex.length === 4
        ? `#${hex
            .slice(1)
            .split("")
            .map((char) => char + char)
            .join("")}`
        : hex;

    // 提取十六进制颜色的红、绿、蓝分量
    const r = parseInt(hexFormatted.slice(1, 3), 16);
    const g = parseInt(hexFormatted.slice(3, 5), 16);
    const b = parseInt(hexFormatted.slice(5, 7), 16);

    // 返回带透明度的 rgba 格式颜色
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } catch (erre) {
    // 默认色
    return "rgba(70,101,249,.1)";
  }
};
export const specialHandling = [
  // 上线酒店
  181470, 187071, 187978, 188611, 188613, 190207, 190247, 207185, 208380,
  // 测试酒店,
  10002,
];
// zkt默认颜色配置
// zkt默认颜色配置
export const defaultColorConfiguration = {
  brandName: "defaultnoneDefault",
  logoUrl: "",
  logoWidth: 140,
  logoHeight: 70,
  primaryColor: "#486bf4",
  slaveColor: "#486bf4",
  slaveTextColor: "#fff",
  sideBarBgColor: "#21233d",
  sideBarSelectedBgColor: "#141523",
  echartBarColor: "#414241",
  slaveTransparent: "#4566f8",
};

/**
 * 需要定制皮肤的酒店配置
 */
export const CustomStyleHotels: Map<number[], CustomTheme> = new Map([
  [
    // 朗廷集团配色
    [214158],
    // [195640],
    {
      brandName: "langham-group",
      logoUrl:
        "https://picssl.zhiketong.com/data/20230313/2e449076e6668f08aba18f8802f6ef04/20230313165004412_x6WxM.png",
      logoWidth: 140,
      logoHeight: 70,
      primaryColor: "#967858", // 棕色
      slaveColor: "#967858",
      slaveTransparent: "rgba(150, 120, 88, 0.62)",
      slaveTextColor: "#fff",
      sideBarBgColor: "#3B3B3D",
      sideBarSelectedBgColor: "#000",
      echartBarColor: "#967858",
    },
  ],
  [
    // 康得思品牌，2023-7-21 新增徐州中心康得思酒店
    [186457, 188087, 188655, 197044, 214054, 229532],
    // [184201],
    {
      brandName: "cordis",
      logoUrl:
        "https://picssl.zhiketong.com/data/20230313/2e449076e6668f08aba18f8802f6ef04/20230313165003995_iO2Aw.png",
      logoWidth: 140,
      logoHeight: 70,
      primaryColor: "#E87722", // 橙色
      slaveColor: "#E87722",
      slaveTransparent: "rgba(232, 119, 34, 0.62)",
      slaveTextColor: "#fff",
      sideBarBgColor: "#000",
      sideBarSelectedBgColor: "#646464",
      echartBarColor: "#E87722",
    },
  ],
  [
    // 朗廷子品牌
    specialHandling,
    // [184686],
    {
      brandName: "langham",
      logoUrl:
        "https://picssl.zhiketong.com/data/20230313/2e449076e6668f08aba18f8802f6ef04/20230313165004672_lHOrW.png",
      logoWidth: 140,
      logoHeight: 70,
      primaryColor: "#000",
      slaveColor: "#FFEEF2", // 粉色
      slaveTransparent: "rgba(255, 238, 242, 0.42)",
      slaveTextColor: "#000",
      sideBarBgColor: "#000",
      sideBarSelectedBgColor: "#414241",
      echartBarColor: "#414241",
    },
  ],
  [
    // 奕凨（红） 2023-7-21 新增金钟奕凨卫理舍
    [228885, 229572],
    // [184569],
    {
      brandName: "YingnFlo",
      logoUrl:
        "https://picssl.zhiketong.com/data/20230313/2e449076e6668f08aba18f8802f6ef04/20230313165004916_5of6o.png",
      logoWidth: 140,
      logoHeight: 70,
      primaryColor: "#F2293E",
      slaveColor: "#F2293E",
      slaveTransparent: "rgba(242, 41, 62, 0.42)",
      slaveTextColor: "#FFF",
      sideBarBgColor: "#000",
      sideBarSelectedBgColor: "#4D4D4F",
      echartBarColor: "#F2293E",
    },
  ],
  [
    // 逸东（橙）
    [228714],
    // [184570, 5],
    {
      brandName: "YiDong",
      logoUrl:
        "https://picssl.zhiketong.com/data/20230313/2e449076e6668f08aba18f8802f6ef04/20230313165005145_BrjcH.png",
      logoWidth: 140,
      logoHeight: 70,
      primaryColor: "#FF4700",
      slaveColor: "#FF4700",
      slaveTransparent: "rgba(255, 71, 0, 0.42)",
      slaveTextColor: "#FFF",
      sideBarBgColor: "#000",
      sideBarSelectedBgColor: "#4D4D4F",
      echartBarColor: "#FF4700",
    },
  ],
]);
